<template>
	<div>
		<template-base class="containerCard">
			<div>
				<div class="mb-2">
					<div class="filter-wrap">
						<section>
							<Filters
								:showFiltersForm="showFiltersForm"
								:showOptionsfilter="[
									'product',
									'product_class',
									'quantity'
								]"
								@clickSearch="setFilterSearch"
								@clickClose="closeFilters"
								:expandedAdvancedFilters="true"
								:optionsProduct="optionsProduct"
								:optionsProductClass="optionsProductClass"
							/>
						</section>
						<div
							class="filter"
							v-bind:class="[showFiltersForm ? 'filter-active' : '']"
							@click="filterDropDownActive"
							title="Alterar Filtros"
						>
							<FilterIcon/>
						</div>
						<b-dropdown no-caret left variant="link" class="p0 container-modal-btn-print" title="Imprimir" v-if="possuiPermissao('REL_V_CONTAS')">
							<template #button-content>
								<printer-icon class="icon-print filter" />
							</template>
							<b-dropdown-item @click="exportData('csv')">CSV</b-dropdown-item>
							<b-dropdown-item @click="exportData('xlsx')">EXCEL</b-dropdown-item>
							<b-dropdown-item @click="exportData('pdf')">PDF</b-dropdown-item>
						</b-dropdown>
					</div>
				</div>
				<div v-if="linhas.length" class="head-row mb-2 width-pagination-items mt-1">
					<div class="text-head-row width-pagination">
						<label class="text-head-row ml-0">
							Resultado {{ pagination.offset + 1 }}-{{ pagination.offset + (linhas.length) }} de {{ pagination.count }}
						</label>
						<b-pagination
							class="mr-0 mb-2 ml-3"
							id="page"
							v-model="currentPage"
							:total-rows="pagination.count"
							:per-page="pagination.limit.value"
						></b-pagination>
					</div>
					<b-form
						class="text-head-row width-pagination">
						<label class="text-head-row ml-0 w-60">
							Itens por página
						</label>
						<b-form-select
							class="mr-0 mb-2"
							v-model="pagination.limit.value"
							name="itens-por-pagina"
							:options="optionsItensPorPag"
							@input="changeItensByPage()"
							:disabled="loading"
						/>
					</b-form>
				</div>
			</div>
			<div v-if="loading || linhas.length" class="table-responsive">
				<DataTable
					class="data-table"
					:loading="loading"
					:colunas="colunas"
					:linhas="linhas"
					:errMsg="errMsg"
					:nosearch="true"
					:nofilters="true"
					name="contas"
					:hasPagination="true"
					:noedit="true"
					:acoes="false"
					:details="false"
					:alignColumns="alignColumnsTable"
					@clickSortTableBy="(v) => sortTableBy(v)"
					:state="{
						sortBy: sortTable.sortBy,
						sortAsc: sortTable.order === 1,
						query: ''
					}"
					:async="true"
				/>
			</div>
			<div v-else class="alert alert-warning" role="alert">
				{{ errMsg }}
			</div>
		</template-base>
		<vue-html2pdf
			:show-layout="false"
			:enable-download="true"
			:preview-modal="false"

			:html-to-pdf-options="htmlToPdfOptions"
			ref="html2Pdf"
			:float-layout="floatLayout"
			:manual-pagination="true"
			@hasDownloaded="finishGeneratePdf"
		>
			<section slot="pdf-content">
				<ReportPDF
					:title="title"
					:rows="rowsReport"
					:headerData="headerData"
					:fields="fields"
					:showLogo="true"
					:rowsPerPage="Number(15)"
					:filtersKeys="filtersActived(filtersSearch)"
					:fontSizeReport="'14'"
					:adjustHeightPage="Number(-8.6)"
					:filterData="filtersSearch"
					:widthPage="'298mm'"
				/>
			</section>
		</vue-html2pdf>
	</div>
</template>

<script>
	import DataTable from "@/components/DataTable";
	import TemplateBase from "@/templates/Base";
	import { possuiPermissao } from "@/helpers/permissions";
	import { ProductService } from "@/services/product";
	import * as XLSX from "xlsx";
	import VueHtml2pdf from "vue-html2pdf";
	import ReportPDF from "../ReportToPDF";
	import { mapState } from "vuex";
	import Filters from "@/components/Transactions/Filters.vue";
	import { numberFormatted, exportCSVFile } from "@/helpers/common";
	import dayjs from "dayjs";
	import "dayjs/locale/pt-br";
	import { ptBR } from "vuejs-datepicker/dist/locale";
	import { filtersActived } from "@/helpers/filters";

	export default {
		components: {
			TemplateBase,
			DataTable,
			VueHtml2pdf,
			ReportPDF,
			Filters
		},

		data () {
			return {
				ptBR,
				optionsProduct: [],
				optionsProductClass: [],
				title: "",
				linhas: [],
				loading: true,
				productService: new ProductService(),
				errMsg: "Nenhum produto cadastrado!",
				colunas: [
					{ value: "Código", sortable: true },
					{ value: "Produto", sortable: true },
					{ value: "Tipo", sortable: true },
					{ value: "Estoque", sortable: false },
					{ value: "Custo", sortable: false },
					{ value: "Venda", sortable: false },
					{ value: "% Lucro", sortable: false },
					{ value: "Total Custo", sortable: false },
					{ value: "Total Venda", sortable: false },
					{ value: "Lucro Total", sortable: false }
				],
				alignColumnsTable: [
					"left",
					"left",
					"left",
					"right",
					"right",
					"right",
					"right",
					"right",
					"right",
					"right"
				],
				pagination: {
					count: 0,
					page: 1,
					offset: 0,
					limit: {
						value: 25
					},
					pages: 1
				},
				currentPage: 1,
				optionsItensPorPag: [
					{
						value: 5,
						text: "5 Items"
					},
					{
						value: 25,
						text: "25 Items"
					},
					{
						value: 50,
						text: "50 Items"
					},
					{
						value: 75,
						text: "75 Items"
					},
					{
						value: 100,
						text: "100 Items"
					}
				],
				possuiPermissao,
				fields : [],
				headerData: {},
				rowsReport: [],
				sortTable: {
					sortBy: 1,
					order: 1
				},
				hideHeaderModal: true,
				isLoading: true,
				showFiltersForm: false,
				floatLayout: true,
				isMobile: false,
				filtersSearch: {},
				totalItens: 0,
				totalCost: 0,
				totalSale: 0,
				userName: "",
				loadPDF: false,
				responseResult: {},
				filtersActived
			};
		},

		computed: {
			htmlToPdfOptions () {
				return {
					margin: [0, 0, 0, 0],
					image: {
						type: "jpeg",
						quality: 0.98
					},
					enableLinks: false,
					filename: `${this.title}.pdf`,
					html2canvas: {
						scale: 2,
						useCORS: true
					},

					jsPDF: {
						unit: "mm",
						format: "a4",
						orientation: "landscape",
						floatPrecision: 16
					}
				};
			},
			...mapState(["product", "productClass"])
		},

		watch: {
			currentPage () {
				this.changePage(this.currentPage);
			}
		},

		async mounted () {
			if (!possuiPermissao("GER_V_PRODUTOS")) {
				return this.$router.push({ path: "*" });
			}
			this.checkIfMobile();
			window.addEventListener("resize", this.checkIfMobile);
			const {
				nomeUsuarioCompleto

			} = JSON.parse(localStorage.params);
			this.userName = nomeUsuarioCompleto;
		},

		beforeMount () {
			this.optionsProduct = [];
			this.product.reduce((acc, ele) => {
				if (!ele.eventual && !ele["productClass.service"]) {
					this.optionsProduct.push({ value: ele.idProduct, nome: ele.description });
				}

				return acc;
			}, []);

			this.optionsProductClass = [];
			this.productClass.reduce((acc, ele) => {
				if (ele.service === "Não") {
					this.optionsProductClass.push({ value: ele.idProductClass, nome: ele.description });
				}

				return acc;
			}, []);
		},
		beforeDestroy () {
			window.removeEventListener("resize", this.checkIfMobile);
		},

		methods: {
			async generarPDF () {
				await this.$nextTick();

				setTimeout(() => {
					this.$refs.html2Pdf.generatePdf();
				}, 300);
			},
			checkIfMobile	() {
				this.isMobile = window.innerWidth <= 768;
			},

			sortTableBy (v) {
				this.sortTable = v;
				this.findProduct();
			},

			changePage () {
				this.pagination.page = this.currentPage;
				this.findProduct();
			},

			changeItensByPage () {
				this.pagination.page = 1;
				this.findProduct();
			},

			async findProduct () {
				const limit = this.pagination.limit.value;
				this.pagination.offset = (this.pagination.page - 1) * limit;
				const offset = this.pagination.offset;
				const sortTable = this.sortTable;

				const filters = {
					offset,
					limit,
					sortTable,
					...this.filtersSearch
				};

				this.responseResult = await this.productService.reportProduct(filters) || {
					rows: [],
					count: 0
				};
				this.linhas = [];

				this.responseResult.rows.forEach((c) => {
					const cost = Number(c.currentCost);
					const sale = Number(c.sale3);
					const quantity = Number(c.quantity);
					const profitMargin = sale && cost ? ((sale - cost) / cost) * 100 : 0;
					const totalCost = cost && quantity ? cost * quantity : 0;
					const totalSale = sale && quantity ? sale * quantity : 0;
					this.linhas.push({
						idProduct: c.idProduct,
						cols: [
							c.barcode || "",
							c.description || "",
							c.nameProductClass || "",
							numberFormatted(c.quantity || "0,00"),
							numberFormatted(c.currentCost || "0,00"),
							numberFormatted(c.sale3 || "0,00"),
							`${numberFormatted(profitMargin || "0,00")}%`,
							numberFormatted(totalCost || "0,00"),
							numberFormatted(totalSale || "0,00"),
							numberFormatted(totalSale - totalCost || "0,00")
						]
					});
				});

				this.pagination.count = this.responseResult.count || 0;
				this.pagination.pages = this.pagination.count > limit ? Math.ceil(this.pagination.count / limit) : 1;
				this.loading = false;
			},

			async exportData (type) {
				try {
					const filters = {
						sortTable: this.sortTable,
						...this.filtersSearch
					};
					this.loading = true;
					this.loadPDF = false;
					this.title = "Relatório de Estoque";
					let data = {};
					if (this.responseResult.rows.length == this.responseResult.count) {
						data = { ...this.responseResult };
					} else {
						data = await this.productService.reportProduct(filters) || {
							rows: [],
							count: 0
						};
					}

					const exportType = {
						pdf: ["barcode", "description", "nameProductClass", "quantity", "currentCost", "sale3", "profitMargin", "totalCost", "totalSale", "profitTotal"],
						xlsx: ["Código", "Produto", "Tipo", "Estoque", "Custo", "Venda", "% Lucro", "Total Custo", "Total Venda", "Lucro Total"],
						csv: ["Código", "Produto", "Tipo", "Estoque", "Custo", "Venda", "% Lucro", "Total Custo", "Total Venda", "Lucro Total"]
					};

					this.rowsReport = [];
					this.totalItens = 0;
					this.totalCost = 0;
					this.totalSale = 0;

					data.rows.forEach((rec) => {
						const cost = Number(rec.currentCost);
						const sale = Number(rec.sale3);
						const quantity = Number(rec.quantity);
						const profitMargin = sale && cost ? ((sale - cost) / cost) * 100 : 0;
						const totalCost = cost && quantity ? cost * quantity : 0;
						const totalSale = sale && quantity ? sale * quantity : 0;

						this.rowsReport.push({
							[exportType[type][0]]: rec.barcode || "",
							[exportType[type][1]]: rec.description || "",
							[exportType[type][2]]: rec.nameProductClass || "",
							[exportType[type][3]]: numberFormatted(quantity || "0,00"),
							[exportType[type][4]]: numberFormatted(cost || "0,00"),
							[exportType[type][5]]: numberFormatted(sale || "0,00"),
							[exportType[type][6]]: `${numberFormatted(profitMargin || "0,00")}%`,
							[exportType[type][7]]: numberFormatted(totalCost || "0,00"),
							[exportType[type][8]]: numberFormatted(totalSale || "0,00"),
							[exportType[type][9]]: numberFormatted(totalSale - totalCost || "0,00")
						});
						this.totalItens += quantity;
						this.totalCost += totalCost;
						this.totalSale += totalSale;
					});

					const profitMarginGeral = this.totalSale && this.totalCost ? ((this.totalSale - this.totalCost) / this.totalCost) * 100 : 0;
					this.rowsReport.push({
						class: "font-weight-bold",
						[exportType[type][0]]: "",
						[exportType[type][1]]: "",
						[exportType[type][2]]: "Totais gerais:",
						[exportType[type][3]]: numberFormatted(Number(this.totalItens)),
						[exportType[type][4]]: "",
						[exportType[type][5]]: "",
						[exportType[type][6]]: "",
						[exportType[type][7]]: numberFormatted(this.totalCost),
						[exportType[type][8]]: numberFormatted(this.totalSale),
						[exportType[type][9]]: numberFormatted(this.totalSale - this.totalCost)
					});

					if (type === "csv") {
						exportCSVFile(this.rowsReport, this.title);
						this.loading = false;
					} else if (type === "xlsx") {
						const worksheet = XLSX.utils.json_to_sheet(this.rowsReport);
						const workbook = XLSX.utils.book_new();
						XLSX.utils.book_append_sheet(workbook, worksheet, "pagina 1");
						XLSX.writeFile(workbook, `${this.title}.xlsx`);
						this.loading = false;
					} else {
						this.floatLayout = false;
						this.loadPDF = true;
						this.fields = [
							{ key: "barcode", label: "Código", style: { width: "30mm", "padding-left": "5px" } },
							{ key: "description", label: "Produto", style: { width: "80mm" } },
							{ key: "nameProductClass", label: "Tipo", style: { width: "28mm" } },
							{ key: "quantity", label: "Estoque", style: { width: "19mm", "text-align": "right" } },
							{ key: "currentCost", label: "Custo", style: { width: "19mm", "text-align": "right" } },
							{ key: "sale3", label: "Venda", style: { width: "19mm", "text-align": "right" } },
							{ key: "profitMargin", label: "% Lucro", style: { width: "22mm", "text-align": "right" } },
							{ key: "totalCost", label: "Total Custo", style: { width: "22mm", "text-align": "right" } },
							{ key: "totalSale", label: "Total Venda", style: { width: "22mm", "text-align": "right" } },
							{ key: "profitTotal", label: "Lucro Total", style: { width: "22mm", "text-align": "right", "padding-right": "5px" } }
						];
						this.headerData = {
							date: dayjs().locale("pt-br").format("DD-MM-YYYY"),
							hour: dayjs().locale("pt-br").format("HH:mm:ss"),
							user: this.userName,
							qtdRows: this.rowsReport.length
						};

						await this.generarPDF();
						this.floatLayout = true;
					}
				} catch (e) {
					console.log(e);
					this.$swal({
						title: "Erro",
						text: `Falha ao exportar dados! - "${e.message}"`,
						type: "error",
						showCancelButton: false,
						confirmButtonColor: "rgb(132, 170, 194)",
						confirmButtonText: "Ok"
					});
				} finally {
					this.loading = false;
				}
			},

			finishGeneratePdf () {
				this.loading = false;
			},

			async setFilterSearch (filtersSelected) {
				this.filtersSearch.quantity = filtersSelected?.quantity || [];
				this.filtersSearch.idsProduct = filtersSelected?.idsProduct || [];
				this.filtersSearch.idsProductClass = filtersSelected?.idsProductClass || [];

				this.closeFilters();
				await this.findProduct();
			},

			filterDropDownActive () {
				this.showFiltersForm = !this.showFiltersForm;
			},

			closeFilters () {
				this.showFiltersForm = false;
			}
		}
	};
</script>

<style scoped>
	.text-conta {
		font-family: 'Roboto Condensed Regular';
		font-size: 20px;
	}

	.label-conta {
		color: #696969 !important;
	}

	.toggle-conta {
		display: flex;
		margin-top: 7px;
		justify-content: center;
	}

	label {
		width: 160px;
	}

	.container-head {
		display: flex;
		height: 3rem;
		width: 100%;
	}

	.container-pages {
		display: flex;
		width: 70%;
		margin-top: 1.5rem;
	}

	.container-btn-print {
		margin-left: -10px;
		margin-top: -10px;
	}

	.container-modal-btn-print {
		margin-left: -5px;
		margin-top: -6px;
	}

	.add-button {
		width: 135;
		height: 43;
		font-family: 'Roboto Condensed Medium';
		background-color: #218838;
		color: #FFFFFF;
		font-size: 20px;
		display: flex;
		justify-content: center;
		align-items: center;
		border-radius: 5px;
		padding: .75rem 1.5rem;
		border-style: none;
		margin-bottom: .5rem;
	}

	.containerCard {
		max-width: 90.5%;
	}

	.head-row {
		display: flex;
		align-items: center;
		width: 100%;
		justify-content: space-between;
		margin-top: -16px;
	}

	.text-head-row {
		display: flex;
		align-items: center;
		justify-content: center;
		font-family: 'Roboto Condensed Bold';
		letter-spacing: -0.05em;
		font-size: 14px;
		color: #6C757D;
	}

	.modal-edicao-label {
		font-family: 'Roboto Condensed Regular';
		font-size: 23px;
	}

	.modal-edicao-input {
		font-family: 'Roboto Condensed Regular';
		font-size: 20px;
	}

	.table-body-detalhe {
		padding: 5px 0;
	}

	.responsive-filter-modal {
		display: flex;
		justify-content: space-evenly;
	}

	.filter-rows {
		width: 50%;
		padding: 1.25rem 0 1.25rem 1.25rem;
		font-size: 1.15rem;
	}
	.filter-rows-next {
		padding-left: 0.8rem;
		padding-right: 1.25rem;
	}

	@media (max-width: 768px) {
		.responsive-filter-modal {
			display: block;
		}
		.filter-rows {
			padding-left: 1.8rem;
			padding-right: 0;
			width: 100%;
		}
		.filter-rows-next {
			padding-top: 0;
			margin-top: -1rem;
		}

	}
</style>